import { createSlice } from "@reduxjs/toolkit";
import {
  getAllProductsService,
  getCategoriesService,
  getProductInfoService,
  addRateService,
  getProductRateService,
  getStoreInfoService,
  getMyCartService,
  getCountriesService,
  getProvincesService,
  placeOrderService,
  getOrderService,
  cancelOrderService,
  updateProfileService,
  getFavoraitesListService,
  getAdvertismentService,
} from "../services/general_service";
import { advertisementsURL } from "../../../urls";

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  isLoadingProduct: false,
  isLoadingCart: false,
  categoriesList: [],
  metaCategories: null,
  productsList: [],
  metaProducts: [],
  productInfo: {},
  isLoadingProductInfo: false,
  productRate: [],
  isLoadingProductRate: false,
  metaProductRate: null,
  filtersData: null,
  storeInfo: {},
  cartList: [],
  metaCart: null,
  countries: [],
  provinces: [],
  ordersList: [],
  metaOrder: null,
  favourateList: [],
  metaFavourate: null,
  advertisementsList: [],
};

const slice = createSlice({
  name: "general",
  initialState,
  reducers: {
    setProductNull: (state, action) => {
      state.productsList = [];
    },
    setFilterData: (state, action) => {
      console.log("action");
      console.log(action.payload);
      state.filtersData = action.payload;
    },
    clearFilters: (state) => {
      state.filtersData = null;
    },
  },
  extraReducers: (builder) => {
    // Using builder callback notation
    builder
      .addCase(getCategoriesService.fulfilled, (state, action) => {
        state.isLoading = false;
        state.categoriesList = action.payload?.data?.data;
        state.metaCategories = action.payload.data.meta.meta;
      })
      .addCase(getCategoriesService.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(getCategoriesService.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAllProductsService.fulfilled, (state, action) => {
        state.isLoadingProduct = false;
        state.productsList = action.payload?.data?.data;
        state.metaProducts = action.payload.data.meta.meta;
      })
      .addCase(getAllProductsService.rejected, (state) => {
        state.isLoadingProduct = false;
      })
      .addCase(getAllProductsService.pending, (state) => {
        state.isLoadingProduct = true;
      })
      .addCase(getProductInfoService.fulfilled, (state, action) => {
        state.isLoadingProductInfo = false;
        state.productInfo = action.payload?.data?.data;
      })
      .addCase(getProductInfoService.rejected, (state) => {
        state.isLoadingProductInfo = false;
      })
      .addCase(getProductInfoService.pending, (state) => {
        state.isLoadingProductInfo = true;
      })
      .addCase(getProductRateService.fulfilled, (state, action) => {
        state.isLoadingProductRate = false;
        state.productRate = action.payload?.data?.data;
        state.metaProductRate = action.payload.data.meta.meta;
      })
      .addCase(getProductRateService.rejected, (state) => {
        state.isLoadingProductRate = false;
      })
      .addCase(getProductRateService.pending, (state) => {
        state.isLoadingProductRate = true;
      })
      .addCase(getStoreInfoService.fulfilled, (state, action) => {
        state.isLoading = false;
        state.storeInfo = action.payload?.data?.data;
      })
      .addCase(getStoreInfoService.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(getStoreInfoService.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getMyCartService.fulfilled, (state, action) => {
        state.isLoadingCart = false;
        state.cartList = action.payload?.data?.data;
        state.metaCart = action.payload.data.meta.meta;
      })
      .addCase(getMyCartService.rejected, (state) => {
        state.isLoadingCart = false;
      })
      .addCase(getMyCartService.pending, (state) => {
        state.isLoadingCart = true;
      })
      .addCase(getCountriesService.fulfilled, (state, action) => {
        state.isLoading = false;
        state.countries = action.payload?.data?.data;
      })
      .addCase(getCountriesService.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(getCountriesService.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getProvincesService.fulfilled, (state, action) => {
        state.isLoading = false;
        state.provinces = action.payload?.data?.data;
      })
      .addCase(getProvincesService.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(getProvincesService.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getOrderService.fulfilled, (state, action) => {
        state.isLoading = false;
        state.ordersList = action.payload?.data?.data;
        state.metaOrder = action.payload.data.meta.meta;
      })
      .addCase(getOrderService.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(getOrderService.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(placeOrderService.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(placeOrderService.rejected, (state, action) => {
        state.isLoading = false;
      })
      .addCase(placeOrderService.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getFavoraitesListService.fulfilled, (state, action) => {
        state.isLoading = false;
        state.favourateList = action.payload?.data?.data;
        state.metaFavourate = action.payload.data.meta.meta;
      })
      .addCase(getFavoraitesListService.rejected, (state, action) => {
        state.isLoading = false;
      })
      .addCase(getFavoraitesListService.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAdvertismentService.fulfilled, (state, action) => {
        console.log(action.payload?.data?.data)
        state.isLoading = false;
        state.advertisementsList = action.payload?.data?.data;
        // state.metaFavourate = action.payload.data.meta.meta;
      })
      .addCase(getAdvertismentService.rejected, (state, action) => {
        state.isLoading = false;
      })
      .addCase(getAdvertismentService.pending, (state) => {
        state.isLoading = true;
      });
  },
});

// Reducer
export default slice.reducer;

// Actions
export const { setProductNull, setFilterData, clearFilters } = slice.actions;
